import styled from '@emotion/styled'

export const StyleBannerWrapper = styled.div`
  background: ${(props: any) => props.theme.colors.white};
  position: relative;
  padding-bottom: 20px;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
`

export const StyleBannerImageWrapper = styled.div`
  img {
    height: 250px;
    width: 100%;
    object-fit: cover;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
  }
`

export const StyleProfileInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 0px 30px;
  margin-top: -50px;
`

export const StyleProfileWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`

export const StyleProfileNameWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 30px;
`

export const StyleTag = styled.div`
  border: 1px solid ${(props: any) => props.theme.colors.white100};
  padding: 7px 7px;
  border-radius: 4px;
  display: flex;
  column-gap: 5px;
  font-size: 12px;
  align-items: center;
`

export const StyleTagsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  aling-itens: center;
  flex-flow: row wrap;
  margin-top: 20px;
  row-gap: 10px;
`
